import { cn } from "@/lib/utils/cn";
import { generateSkeletonArray } from "@/lib/utils/skeletonUtils";
import { SkeletonBase } from "./SkeletonBase";

/**
 * Card skeleton loader
 * @param {Object} props - Component props
 * @param {number} props.count - Number of cards to display (default: 3)
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.hasImage - Whether to show image skeleton (default: false)
 * @param {boolean} props.hasTitle - Whether to show title skeleton (default: true)
 * @param {number} props.lines - Number of content lines (default: 2)
 */
export function CardSkeleton({
  count = 3,
  className,
  hasImage = false,
  hasTitle = true,
  lines = 2,
}) {
  const cardArray = generateSkeletonArray(count);
  const lineArray = generateSkeletonArray(lines);

  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4", className)}>
      {cardArray.map((index) => (
        <div
          key={`card-${index}`}
          className="card bg-base-100 shadow-sm border border-base-300 p-4"
        >
          {/* Image skeleton */}
          {hasImage && <SkeletonBase variant="card" className="h-48 mb-4" />}

          {/* Title skeleton */}
          {hasTitle && <SkeletonBase variant="line" className="h-6 w-3/4 mb-3" />}

          {/* Content lines */}
          <div className="space-y-2">
            {lineArray.map((lineIndex) => (
              <SkeletonBase
                key={`line-${lineIndex}`}
                variant="line"
                className={lineIndex === lines - 1 ? "w-1/2" : "w-full"}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
